import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=19e50bf9&scoped=true"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=19e50bf9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e50bf9",
  null
  
)

export default component.exports